import { Text } from '@/components/common';
import AddNewPaymentModal from '@/components/modal/AddNewPayment';
import { useUser } from '@/hooks/useUser';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { CARD_TYPE } from '@/utils/constant';
import { ModalRenderer } from '@/utils/modalUtils';
import { get } from 'lodash';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CardListForCP from './CardListForCP';
import { AddPaymentMethodBtnForCP, ContinueBtnForCP, DepositPaymentWrapper } from './styled';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const DepositPayment: React.FC<any> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userId = useAppSelector((state: any) => state.auth.userId);
  const cardList = useAppSelector((state: any) => get(state, 'user.userInfo.credit_cards'));
  const cardWithoutApplePay = cardList?.filter((card: any) => card.wallet !== CARD_TYPE.APPLE);

  const dispatch = useAppDispatch();
  const [reloadUser] = useUser(userId);

  useEffect(() => {
    (async () => {
      dispatch({ type: 'SHOW_LOADING' });
      try {
        await reloadUser();
      } catch (error) {
        console.log(error);
      } finally {
        dispatch({ type: 'HIDE_LOADING' });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cardWithoutApplePay?.length > 0) {
      dispatch({
        type: 'UPDATE_STATUS',
        payload: { deposit_passed: true },
      });
    } else {
      dispatch({
        type: 'UPDATE_STATUS',
        payload: { deposit_passed: false },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardWithoutApplePay]);

  const onHandleContinue = async () => {
    const kycId = localStorage.getItem('kyc_id');
    window.location.href = `/kyc/${kycId}/result`;
  };

  const addPaymentMethod = async () => {
    ModalRenderer.open({
      component: AddNewPaymentModal,
      theme: 'white',
      inMobile: 'bottom',
    });
    return;
  };

  const onBack = () => {
    navigate('/insurance-declaration');
  };
  return (
    <>
      <Box sx={{ mb: { md: 4, xxs: 3 } }}>
        <img
          style={{ width: '32px', height: '32px', cursor: 'pointer' }}
          src="/images/icon/icon_back.svg"
          onClick={onBack}
          alt=""
        />
      </Box>
      <Text color="darkPrimary" variant="title">
        {t('PAYMENT_METHOD')}
      </Text>
      <Text color="darkSecondary" variant="content" size="16">
        <Trans
          i18nKey="DEPOSIT_PAYMENT_SUBTITLE"
          components={{
            link1: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                href="https://help.theout.com/s/article/How-much-is-the-deposit-to-secure-my-booking"
                target="blank"
              />
            ),
          }}
        />
      </Text>
      <DepositPaymentWrapper>
        <CardListForCP cardList={cardWithoutApplePay} />
        {cardWithoutApplePay?.length ? (
          <>
            <Text
              color="darkSecondary"
              variant="content"
              size="16"
              style={{ textDecoration: 'underline', marginBottom: '32px', marginTop: '8px', cursor: 'pointer' }}
              onClick={addPaymentMethod}
            >
              {t('ADD_PAYMENT_METHOD')}
            </Text>
            <AddPaymentMethodBtnForCP fullWidth variant="contained" color="white" onClick={onHandleContinue}>
              {t('DEPOSIT_CONTINUE_BTN')}
            </AddPaymentMethodBtnForCP>
          </>
        ) : (
          <ContinueBtnForCP fullWidth variant="contained" color="white" type="submit" onClick={addPaymentMethod}>
            {t('ADD_PAYMENT_METHOD')}
          </ContinueBtnForCP>
        )}
      </DepositPaymentWrapper>
    </>
  );
};
export default DepositPayment;
